import React, { SVGProps } from 'react';

export const EditableCellTickIcon = ({
  className,
  style,
  width,
  height,
  fill,
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={width || '8'}
    height={height || '6'}
    fill={fill || 'none'}
    className={className}
    style={style}
    viewBox="0 0 8 6"
    xmlns="http://www.w3.org/2000/svg"
    data-palette="EditableCellTickIcon">
    <path
      d="M3.19892 4.0688L6.87572 0.391598L7.44172 0.957198L3.19892 5.2L0.65332 2.6544L1.21892 2.0888L3.19892 4.0688Z"
      fill="var(--positive)"
    />
  </svg>
);

export default EditableCellTickIcon;
